<template>
  <div class="bg-surface top-0 z-10 mb-8 px-4 pt-6 pb-4">
    <div class="mb-4 flex flex-row items-center gap-1 pt-10">
      <div
        v-for="skill in skills"
        :key="skill.id"
        class="rounded-medium flex flex-row items-center gap-2 px-3 py-1"
        :class="[`bg-${skill.color}-90`, `text-${skill.color}-40`]"
      >
        <span class="h-3 w-3 rounded-full" :class="[`bg-${skill.color}-60`]"></span>
        <span class="text-body-large">{{ skill.title }}</span>
      </div>
    </div>
    <h3 class="text-headline-small md:text-headline-large">
      {{ content }}
    </h3>
  </div>
</template>

<script setup lang="ts">
  import type { Skill } from '@/core/models/skill.ts'

  defineProps<{
    readonly content: string
    readonly skills: ReadonlyArray<Skill>
  }>()
</script>
